module.exports = __webpack_public_path__ + "img/fish-dinner.a8c19a0f.jpg";